import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { canManagePingolfLeague, LEAGUE_PATH, EVENTS_PATH } from '../utils/pingolfNav';
import './BottomNavShell.css';
import './PinGolfBottomNav.css';
import { DSIcon } from '../design-system/primitives';

const BASE_TABS = [
  { path: LEAGUE_PATH, icon: <DSIcon name="trophy" />, label: 'League', match: (p) => p === LEAGUE_PATH }
];

// The raw events list is an organizer tool for now - members come in through the League screen,
// which links to the next event anyway. The /pingolf route is unchanged and still reachable by
// direct link; this only removes the tab.
const EVENTS_TAB = { path: EVENTS_PATH, icon: <DSIcon name="golf" />, label: 'Events', match: (p) => p === EVENTS_PATH };

// Keep tab labels short. A label that wraps to a second line makes this whole bar
// taller than every other bottom nav in the app (see the nowrap rule in the CSS).
const ADMIN_TAB = { path: '/pingolf-season/admin', icon: <DSIcon name="settings" />, label: 'Admin', match: (p) => p.startsWith('/pingolf-season/admin') };
const CREATE_TAB = { key: 'create', icon: <DSIcon name="plus" />, label: 'Create Event' };

function PinGolfBottomNav({ onCreateEvent }) {
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = authService.getCurrentUser();
  const isAdmin = currentUser?.role === 'admin';
  const tabs = canManagePingolfLeague(currentUser) ? [...BASE_TABS, EVENTS_TAB, ADMIN_TAB] : BASE_TABS;

  const handleCreateEvent = () => {
    if (onCreateEvent) {
      onCreateEvent();
    } else {
      navigate(EVENTS_PATH, { state: { openCreate: true } });
    }
  };

  return (
    <nav className="bn-shell pgbn-bottomnav">
      {tabs.map((tab) => {
        const isActive = tab.match(location.pathname);
        return (
          <button
            key={tab.label}
            type="button"
            className={`bn-shell-item pgbn-bottomnav-item ${isActive ? 'active' : ''}`}
            onClick={() => navigate(tab.path)}
          >
            <span className="bn-shell-icon pgbn-bottomnav-icon">{tab.icon}</span>
            <span className="pgbn-bottomnav-label">{tab.label}</span>
          </button>
        );
      })}
      {isAdmin && (
        <button
          key={CREATE_TAB.key}
          type="button"
          className="bn-shell-item pgbn-bottomnav-item"
          onClick={handleCreateEvent}
        >
          <span className="bn-shell-icon pgbn-bottomnav-icon">{CREATE_TAB.icon}</span>
          <span className="pgbn-bottomnav-label">{CREATE_TAB.label}</span>
        </button>
      )}
    </nav>
  );
}

export default PinGolfBottomNav;
